import styles from './Spinner.module.css';
import logo from '../../assets/images/logo-icono.png';

export function Spinner() {
  return (
    <div className={styles.spinner}>
      <img
        src={logo}
        alt="Logo Provincia"
        className={styles.logo}
      />
    </div>
  );
}